import { render, staticRenderFns } from "./sub-heads.vue?vue&type=template&id=18c0673a&scoped=true&"
import script from "./sub-heads.vue?vue&type=script&lang=js&"
export * from "./sub-heads.vue?vue&type=script&lang=js&"
import style0 from "./sub-heads.vue?vue&type=style&index=0&id=18c0673a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c0673a",
  null
  
)

export default component.exports